import React from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import { RouterStage } from './core/router'
import { ChangeLogStore, CacheBuster } from './core/versioning'
import SystemSettingStore from './shared/stores/systemSetting.store'
import UserProfileService from './shared/services/UserProfile.service'
import UserService from './shared/services/User.service'
import { AnalyticsTracker, ErrorBoundary } from './hoc'
import InactivityTimer from './hoc/InactivityTimer.component'
import ScrollToTop from './components/shared/ScrollToTop.component'
import LiveLeaderboardSidebar from './components/reporting/LiveLeaderboardSidebar'
import { PushNotificationsBootstrap } from './components/push'

import './index.scss'

function App() {
  const routeChange = () => {}

  return (
    <CacheBuster>
      {({ isLoading, isLatestVersion, availVersion, runningVersion }) => {
        if (isLoading) return null
        else if (UserProfileService.getUserId() > 0) {
          if (!isLatestVersion && availVersion && runningVersion) {
            console.log(`Version has changed: ${availVersion}. Please refresh`)
            ChangeLogStore.refreshCacheAndReload(availVersion)
          } else if (!isLatestVersion && availVersion) {
            console.log(`Version is new: ${availVersion}. Please refresh`)
            ChangeLogStore.refreshCacheAndReload(availVersion)
          } else if (parseInt(UserProfileService.get('completed_enroll')) !== 1) {
            if (/\/[A-Za-z0-9-]+\/enroll/.test(window.location.pathname)) {
              UserService.hasCompletedEnroll(UserProfileService.getUserId()).then(res => {
                if (res && res?.completed_enroll === true) {
                  UserProfileService.set('completed_enroll', 1)
                  window.location.href =
                    `${UserProfileService.get('has_onboarded')}` === '1' ? '/dashboard' : '/welcome'
                }
              })
            }
          } else {
            console.log(`You already have the latest version - ${availVersion}. No refresh needed.`)
            ChangeLogStore.fetchChangeLog({
              isLatestVersion,
              availVersion,
              runningVersion,
            })
          }
        }

        SystemSettingStore.load()

        return (
          <ErrorBoundary>
            <InactivityTimer />
            <AnalyticsTracker />
            {/* Renders nothing. Starts web-push enrolment after mount (never
                during boot) so registering the FCM worker at its own narrow
                scope cannot race the Workbox cache-busting worker's install. */}
            <PushNotificationsBootstrap />
            <Router onChange={routeChange}>
              <ScrollToTop />
              <RouterStage />
              {/* Mounted at the Router level (not inside per-page DashboardLayout)
                  so it persists across route changes — no remount, no skeleton
                  flash, no re-hydration. The guard component handles its own
                  auth + role visibility. `disabledRoutes` skips chromeless
                  surfaces (e.g. the /10x-sales-tracker GHL iframe) that don't
                  carry the Firebase auth Echo + LiveLeaderboardService need;
                  `enabledRoutes` is the inverse opt-in for non-auth pages. */}
              <LiveLeaderboardSidebar
                disabledRoutes={[
                  // misc / chromeless / backend-served
                  '/10x-sales-tracker',
                  '/wheel-of-love',
                  // full-screen office TV display
                  '/big-screen',
                  // recruiting meeting iframe shells (bare-shell Zoom Client View host)
                  '/usabg-opportunity/zoom-host',
                  '/usabg-opportunity/meeting-ended',
                  // authentication
                  '/login',
                  '/forgot-password',
                  '/reset-password',
                  '/account-password',
                  // onboarding wizards
                  '/welcome',
                  '/getting-started',
                ]}
              />
            </Router>
          </ErrorBoundary>
        )
      }}
    </CacheBuster>
  )
}

export default App
